//      
import {              } from 'css-box-model';
                                        
import isWithin from '../is-within';
import { vertical } from '../axis';

export default (axis      ) => (frame         ) => {
  const isWithinVertical = isWithin(frame.top, frame.bottom);
  const isWithinHorizontal = isWithin(frame.left, frame.right);

  return (subject         ) => {
    if (axis === vertical) {
      return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
    }
    return (
      isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right)
    );
  };
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/visibility/is-totally-visible-through-frame-on-axis.js